// InvoiceHistory.js - Component for displaying and managing invoice history.
// Updated: loadInvoice() now sets isLoadedInvoice to true in global context, ensuring proper flag management for exports.
// Fixed: Use 'exportedAt' instead of 'timestamp' for date display to match refactored GlobalContext.js; added fallback to 'timestamp' for backward compatibility.
import React from 'react';
import { ListGroup, Button, Container } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { useGlobalContext } from '../hooks/useGlobalContext';
import { useTranslation } from 'react-i18next';

const InvoiceHistory = ({ setCurrentView }) => {
  const { invoiceHistory, deleteInvoiceFromHistory, loadInvoice } = useGlobalContext();
  const { t } = useTranslation();

  // Function to handle loading an invoice
  const handleLoadInvoice = (id) => {
    const invoice = loadInvoice(id); // Updated: This now sets currentInvoice and isLoadedInvoice to true in global context
    if (invoice) {
      setCurrentView('form'); // Switch to form view after loading
    }
  };

  return (
    <Container className="mt-4">
      <h2>{t('invoiceHistory')}</h2>
      {invoiceHistory.length === 0 ? (
        <p>{t('noInvoiceHistoryMessage')}</p>
      ) : (
        <ListGroup>
          {invoiceHistory.map((invoice) => (
            <ListGroup.Item key={invoice.id} className="d-flex justify-content-between align-items-center">
              <div onClick={() => handleLoadInvoice(invoice.id)} style={{ cursor: 'pointer' }}>
                {t('invoice')} #{invoice.invoiceNumber} - {new Date(invoice.exportedAt || invoice.timestamp).toLocaleDateString()}  {/* Fixed: Use 'exportedAt' with fallback to 'timestamp' for backward compatibility */}
              </div>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => deleteInvoiceFromHistory(invoice.id)}
              >
                <FaTrash />
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </Container>
  );
};

export default InvoiceHistory;